import { useState, useEffect } from "react";
import { Render } from "@puckeditor/core";
import "@puckeditor/core/puck.css";
import { config } from "../puck/config";
import { getPublishedPage } from "../../service/weexpertService";
import { CircularProgress } from "@mui/material";

export default function MainPageRendered() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    getPublishedPage()
      .then((res) => {
        setData(res.data.content);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setNotFound(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CircularProgress />
      </div>
    );
  }

  if (notFound || !data) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-gray-500">Page not found</p>
      </div>
    );
  }

  return (
    <div className="px-10 py-10">
      <Render config={config} data={data} />
    </div>
  );
}
